export default __webpack_public_path__ + "static/classico-8f144f52adf5a0de1be56759b4ace7e0.png";